import React from "react";

export function PageHeader({ eyebrow, title, description, actions, className = "" }) {
  return (
    <header className={`flex items-end justify-between flex-wrap gap-6 ${className}`}>
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold font-semibold mb-3">{eyebrow}</p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-white">{title}</h1>
        {description && (
          <p className="mt-3 text-sm text-zinc-500 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
    </header>
  );
}

export default PageHeader;
